module.exports = __webpack_public_path__ + "static/media/TreySeniorPhoto2.271db2c9.jpg";